import { render, staticRenderFns } from "./UnitsConfiguration.vue?vue&type=template&id=35281d95"
import script from "./UnitsConfiguration.vue?vue&type=script&lang=js"
export * from "./UnitsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports